import React, { useEffect, useState } from 'react'
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { stepLabelClasses } from '@mui/material/StepLabel';
import { Body, Micro } from '@vds3/typography';
import styled from 'styled-components';
import './VZStepper.css'
import { useTranslation } from "react-i18next";
import { checkIfAemExists } from 'utils/commonUtils';
import { useDispatch, useSelector } from 'react-redux';
import { checkForGWReinitiateFlow, checkForGWSteps, checkIfPDPFlowFresh, getActiveStep, getBYODText, getCompletedSteps, getFlow, getReInitiatedFlow, handleCheckMarkClick, isFlowChanged, reinitiateFlowIfSessionIsEmpty } from './VZStepperGetSteps';
import { setCurrentFlowForHPB, setCurrentActiveStep, setCompletedPagesForHPB, setReinitiateFlow } from 'app/ducks/GlobalSlice';
import { useMediaQuery } from 'react-responsive';
import useNavigate from "hooks/useNavigate";
import { CompactProgressIndicator,Accordion,Text  } from '@vbg-ds/core';
import { Grid, Col, Row } from "@vds3/grids";

const ConnectorWrapper = styled(StepConnector)({
  [`&.${stepLabelClasses.labelContainer}`]: {
    textAlign: 'start'
  },
  [`&.${stepLabelClasses.active}`]: {
    [`&.${stepLabelClasses.label}`]: {
      display: 'contents',
      alignItems: 'flex-start',
      textAlign: 'start'
    },
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#008331',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#008331',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,

  },
});

const StepperContainer = styled(Stepper)`
  display: flex;
  flex-direction: row;
  alignItems: flex-start;
  .MuiStepLabel-label{
  margin-top: 24px !important;
  }
  .MuiStepLabel-labelContainer{
  position:relative;
  top:-58px;
  }
  .MuiStepConnector-alternativeLabel{
  top:10px;
  left: calc(-95% + 16px);
  right: calc(90% + 16px);
  align-items: flex-start;
  margin-left:auto;
  justify-content:flex-end;
  }
  .MuiStepLabel-iconContainer{
  z-index:1;
  background-color:white;
  }
  @media screen and (max-width:1024px){
  .MuiStepLabel-horizontal{
  width:100% !important;
  }
  .MuiStepLabel-labelContainer{
  top:-60px;
  }
  }
  @media screen and (max-width:767px){
    .miui-stp-atv .MuiStepConnector-alternativeLabel{
      width: ${158.5 * 1.5}% !important;
    }
    .miui-stp-atv-0 .MuiStepConnector-alternativeLabel{
      right: ${({ stepsCount }) => stepsCount === 4 ? "calc(65% + 55px) !important" : stepsCount === 5 ? "calc(65% + 40px) !important" : stepsCount === 6 ? "calc(65% + 30px) !important" : ""};
    }
    .MuiStepConnector-alternativeLabel{
    right: ${({ stepsCount }) => stepsCount === 3 ? "calc(85% + 16px) !important" : ''};
    left: ${({ stepsCount }) => stepsCount === 3 ? "calc(7% + 16px) !important" : ''};
    }
  }
  @media screen and (min-width:950px){
  .MuiStepConnector-alternativeLabel{
  right:${({ stepsCount }) => stepsCount === 3 ? "calc(95% + 22px)" : stepsCount === 4 ? "calc(92% + 22px)" : stepsCount > 5 ? "calc(90% + 14px)" : "calc(90% + 22px)"};
  left:${({ stepsCount }) => stepsCount === 3 ? "calc(-96% + -3px)" : stepsCount === 4 ? "calc(-97% + -3px)" : "calc(-95% + 8px)"};
  }
`;

const DivWrapper = styled.div`
width:${({ stepsCount }) => stepsCount > 4 ? (100 + (41 - ((stepsCount * 3) + (stepsCount - (6 - stepsCount))))) : '130'}.4% !important;
@media screen and (max-width:767px){
width:${({ stepsCount }) => ((100 + (24 - ((stepsCount - 1) * 3))) - 0.4)}% !important;
}
`;

const VZStepperChild = (props) => {
  const isMobile = useMediaQuery({
    query: "(max-width: 767px)",
  });

  const { t, ready } = useTranslation(["horizontal-progress-bar", "app"]);
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const globalData = useSelector((state) => state.ProspectWidgets_GlobalData);
  const pageData = useSelector((state) => state.ProspectWidgets_MobilityData);
  const [stepsForVDS, setStepsForVDS] = useState([]);
  const navigatePath = useSelector((state) => state.ProspectWidgets_GlobalData?.navigatePath);
  const hasAccount = (globalData?.sessionCartData && globalData?.sessionCartData?.apiResponse && globalData?.sessionCartData?.apiResponse?.prospectFlowData &&
    globalData?.sessionCartData?.apiResponse?.prospectFlowData?.businessInfo && globalData?.sessionCartData?.apiResponse?.prospectFlowData?.businessInfo?.shellAccountNumber) ? false : true
  const LQData = useSelector((state) => state.ProspectWidgets_LQPage);
  const isByorSelected = LQData?.selectedRouterType === "own_routers";
  const steps = t(`progressbar.${globalData.currentFlowForHPB}`, { ns: "horizontal-progress-bar", returnObjects: true });
  const showProgressBar = checkIfAemExists(t("showProgressBar", { ns: "horizontal-progress-bar" }))
  let activeStepCurrent = getActiveStep({ steps, pathForDevices: t(`progressbar.pathForLoggedInFlow`, { ns: "horizontal-progress-bar", returnObjects: true }), currentActiveIndex: globalData.currentActiveStep, reinitiateFlow: globalData.reinitiateFlow, completedPagedForHPB: globalData.completedPagedForHPB, navigatePath })
  const plansFirstCategories = t('plans-first.category', { ns: "app", returnObjects: true });
  const completedSteps = getCompletedSteps({ steps, pathForDevices: t(`progressbar.pathForLoggedInFlow`, { ns: "horizontal-progress-bar", returnObjects: true }), completedPagedForHPB: globalData.completedPagedForHPB, reinitiateFlow: globalData.reinitiateFlow, activeIndex: globalData.currentActiveStep, isPlansFirstFlow: false })
  const getDefaultPath = isByorSelected
    ? t("progressbar.loadDefaultPathForLoggedInByor", { ns: "horizontal-progress-bar", returnObjects: true })
    : t("progressbar.loadDefaultPathForLoggedIn", { ns: "horizontal-progress-bar", returnObjects: true })

  const isPlansFirstFlow = (globalData.currentFlowForHPB === 'planFirstSteps' || globalData.currentFlowForHPB === 'planFirstStepsWithProtection')
    && (globalData.flow === 'plans-first' && globalData.isEditPlansFlow)
  const isRetrieveCart = false
  useEffect(() => {
    if (!globalData.currentFlowForHPB) {
      const flow = getFlow({ showProtection: globalData.metaInformation?.showProtectionFeaturesOnPDP, haveJO: globalData.selectedIndexForFWAHPB === 1 ? true : false, globalData: globalData, pathForSteps: getDefaultPath, hasAccount: hasAccount, fromMarketplace: props?.fromMarketplace, selectAccountFlow: props?.selectAccountFlow, navigatePath: globalData?.navigatePath,isByor:props?.isByor,isSingleAddress:props?.isSingleAddress })
      if (flow && flow != "") {
        dispatch(setCurrentFlowForHPB(flow))
        activeStepCurrent = 0
        dispatch(setCurrentActiveStep(0))
      }
    }
  }, [globalData.currentFlowForHPB, globalData.selectedIndexForFWAHPB, globalData.category, globalData.categoryForHPB])

  useEffect(() => {
    if (globalData?.currentActiveStep < activeStepCurrent)
      dispatch(setCurrentActiveStep(activeStepCurrent))
  }, [[activeStepCurrent]])

  useEffect(() => {
    if (globalData.currentFlowForHPB) {
      const stepsForCurentFlow = globalData.currentFlowForHPB ? t(`progressbar.${globalData.currentFlowForHPB}`, { ns: "horizontal-progress-bar", returnObjects: true }) : []
      if (stepsForCurentFlow && stepsForCurentFlow.length) {
        let finalStep = []
        const completedSteps = getCompletedSteps({ steps, pathForDevices: t(`progressbar.pathForLoggedInFlow`, { ns: "horizontal-progress-bar", returnObjects: true }), completedPagedForHPB: globalData?.completedPagedForHPB, reinitiateFlow: globalData.reinitiateFlow, activeIndex: globalData.currentActiveStep, isPlansFirstFlow: isPlansFirstFlow, isRetrieveCart: isRetrieveCart })
        stepsForCurentFlow.map((data, index) => {
          finalStep.push({
            "label": {
              "children": isMobile ? globalData?.currentActiveStep === index ? data : '' : data
            },
            "readonly": false,
            "status": (completedSteps && completedSteps.length && completedSteps.includes(index)) ? "complete" : "open",
            "selected": globalData?.currentActiveStep === index ? true : false,
            onClick: () => {
              if ((completedSteps && completedSteps.length && completedSteps.includes(index))) {
                handleStep(getBYODText({ index, text: data, pages: globalData?.completedPagedForHPB }), t(`progressbar.pathForDeviceFirstSteps`, { ns: "horizontal-progress-bar", returnObjects: true }), globalData.currentFlowForHPB, navigate, labelPaths, globalData.planFirstQS, isfromAgentLinkPage, packageTypeForByod)
              }

            }
          })
        })
        if (finalStep && finalStep.length) setStepsForVDS(finalStep)
      }

    }
  }, [globalData.currentFlowForHPB, globalData?.completedPagedForHPB, globalData?.currentActiveStep])

  useEffect(() => {
    let flow = globalData.currentFlowForHPB
    let planFirstFlow = false
    flow = getFlow({ showProtection: globalData.metaInformation?.showProtectionFeaturesOnPDP, haveJO: globalData.selectedIndexForFWAHPB === 1 ? true : false, globalData: globalData, pathForSteps: getDefaultPath, isByorSelected: isByorSelected, navigatePath: globalData?.navigatePath })

    if (globalData.reinitiateFlow) {
      if (((globalData.currentFlowForHPB === 'planFirstSteps' || globalData.currentFlowForHPB === 'planFirstStepsWithProtection')
        && (globalData.flow === 'plans-first' && globalData.isPlanFirstFlowCompleted))
        // || ((globalData.currentFlowForHPB === 'titleForLTEWithJOWithProtection' || globalData.currentFlowForHPB === 'titleForLTEWithJO') && activeStepCurrent > 2)
      ) {
        planFirstFlow = true
        flow = getFlow({ showProtection: globalData.metaInformation?.showProtectionFeaturesOnPDP, haveJO: globalData.selectedIndexForFWAHPB === 1 ? true : false, globalData: globalData, pathForSteps: getDefaultPath, navigatePath: globalData?.navigatePath })
        if (flow && flow != "") {
          dispatch(setCurrentFlowForHPB(flow))
          activeStepCurrent = 0
          dispatch(setCurrentActiveStep(0))
        }
      }

      const { completedSteps, activeStep } = getReInitiatedFlow({
        completedPagedForHPB: globalData.completedPagedForHPB, flow: flow, getIndexFromAEM: t("progressbar.getIndexForReInitiatedFlow",
          { ns: "horizontal-progress-bar", returnObjects: true }), currentActiveStep: globalData?.currentActiveStep, planFirstFlow,
        pathForDevices: t(`progressbar.pathForDeviceFirstSteps`, { ns: "horizontal-progress-bar", returnObjects: true })
      })
      let activeStepValue = getActiveStep({
        steps, pathForDevices: t(`progressbar.pathForDeviceFirstSteps`, { ns: "horizontal-progress-bar", returnObjects: true }),
        currentActiveIndex: globalData.currentActiveStep, reinitiateFlow: globalData.reinitiateFlow, completedPagedForHPB: completedSteps
      })
      dispatch(setCompletedPagesForHPB(completedSteps))
      dispatch(setCurrentActiveStep(activeStepValue))
      dispatch(setReinitiateFlow(false))
    }
  }, [globalData.reinitiateFlow])

  useEffect(() => {
    if (!globalData.reinitiateFlow)
      dispatch(setCompletedPagesForHPB(checkForGWSteps(globalData.completedPagedForHPB)))
  }, [])

  const CompletedIcon = (props) => {
    const { active, completed, className } = props;
    if (completed) {
      return (
        <div className='chck-mrk-outline' onClick={() => handleCheckMarkClick({ currentStep: steps[active - 1], navigate, pathForDevices: t("progressbar.labeRedirectPathsForLoggedIn", { ns: "horizontal-progress-bar", returnObjects: true }), fromProspect: props?.fromProspect })}>
          <img src={`https://scache.vzw.com/unified-checkout/assets/images/CheckMark.png`} alt="checkmark" width={'12px'} height={'7.95px'} />
          {/* <Checkmark color={'white'} size="small" /> */}
        </div>
      )
    }
    else {
      return <div style={{ position: 'relative', top: '-1px', marginTop: '2px', width: '18px', height: '18px', borderRadius: '50%', border: active ? '2px solid #008331' : '2px solid #D8DADA', cursor: active ? 'pointer' : '' }}
        onClick={() => {
          if (active) handleCheckMarkClick({ currentStep: steps[active - 1], navigate, pathForDevices: t("progressbar.labeRedirectPathsForLoggedIn", { ns: "horizontal-progress-bar", returnObjects: true }), fromProspect: props?.fromProspect })
        }}></div>
    }
  }
  const show25Percent = t("progressbar.show25PercentProgress", { ns: "horizontal-progress-bar", returnObjects: true })
  const isPDPActive = checkIfPDPFlowFresh({ deviceName: globalData?.storeGridwallPDP, accessoryName: globalData?.storeAccessoryPDP, completedSteps: globalData.completedPagedForHPB, activeIndex: globalData.currentActiveStep })
  let classNameForActive = 'miui-stp-atv'
  // if(!!show25Percent && show25Percent.length && typeof show25Percent == "object" && show25Percent.includes(globalData.currentFlowForHPB) ){
  if (isPDPActive) classNameForActive = 'miui-stp-atv-grd-75 miui-stp-atv'
  else classNameForActive = 'miui-stp-atv-grd miui-stp-atv'
  // }
  const classNameForMobile = ` vz-stepper-wdth-mob-${(steps && steps.length) ? steps.length : ''}`
  const loadProgressBar = checkIfAemExists(t("progressbar.enableProgressBarForLoggedIn"))
  if (loadProgressBar) {
     if(isMobile){
      return(
        <div style={{width:'100%'}} >
        <Accordion
        behavior="singleOpen"
        id="vz-stppr-isMobile-nw"
        fullBleed={true}
        contentWidth="100%"
        width={'100%'}
        items={
          [
             {
              opened:false,
              children:  <div className='new-vz-stppr'>
                  <CompactProgressIndicator
                    items={[...stepsForVDS]}
                    labelPosition={props?.orientation ? props?.orientation : "top"}
                    orientation="vertical"
                    surface="lightPrimary"
                  />
              </div> ,
              header: {
                fullBleed:true,
                ariaLabel: '',
                title: {
                  children: 
                    <div style={{display:'flex',gap:'8px',alignItems:'flex-start'}}>
                      <div className='vz-stppr-icon-btn'/>
                      <div>
                  <Text kind='body' size='small' bold={true} >Step {globalData?.currentActiveStep+1}/{stepsForVDS.length}</Text>
                   <Text kind='body' size='small' bold={true} >{steps[globalData?.currentActiveStep]}</Text>
                  </div>
                  </div>
                 
                }
              },
              trigger: {
                closeLabel: 'Collapse',
                openLabel: 'Show all'
                
              },
              triggerElement: 'link'
            }
          ]
        }
        >
      
  </Accordion>
  </div>
      )
    }
  else{
  return (
    <div className='new-vz-stppr'>
       <CompactProgressIndicator
    items={[...stepsForVDS]}
    labelPosition={props?.orientation ? props?.orientation : "top"}
    orientation="horizontal"
    surface="lightPrimary"
  />
  </div>
  )
}
    return (
      <div className={!isMobile ? 'vz-stepper-main-container vz-stepper-main-container-padding' : 'vz-stepper-main-container mv-vw-vz-stpr'} style={{ marginTop: '2rem', overflow: 'hidden' }}>
        {/* TODO: showUpperFunnelProgressBar - need to negate this flag */}
        <div className="full-width-stpper">
          <DivWrapper stepsCount={(steps && steps.length) ? steps.length : 0} className={((steps && steps.length === 3) ? 'vz-stpper-3' : 'vz-stpper-wdth') + classNameForMobile} style={{ margin: 'auto', marginTop: '1rem' }}>
            <StepperContainer
              stepsCount={(steps && steps.length) ? steps.length : 0}
              alternativeLabel={true}
              connector={<ConnectorWrapper />}
              orientation={'horizontal'}
              activeStep={globalData?.currentActiveStep}>
              {(steps && steps instanceof Array) && steps.map((label, index) => (
                <Step key={label} completed={completedSteps.includes(index) ? true : false} className={(index === (globalData?.currentActiveStep + 1)) ? classNameForActive : (index === globalData?.currentActiveStep) ? 'miui-stp-atv-0' : ''} >
                  <StepLabel StepIconComponent={CompletedIcon} style={{ alignItems: 'flex-start', width: isMobile ? '40%' : '' }} >
                    <div size="small" style={{ display: 'flex', alignItems: 'self-start' }} onClick={() => {
                      if ((index === globalData?.currentActiveStep || completedSteps.includes(index))) handleCheckMarkClick({ currentStep: label, navigate, pathForDevices: t("progressbar.labeRedirectPathsForLoggedIn", { ns: "horizontal-progress-bar", returnObjects: true }), fromProspect: props?.fromProspect })
                    }}>
                      <Micro size='small' bold={(index === globalData?.currentActiveStep) ? true : false}>
                        <div style={{ textDecoration: (index === globalData?.currentActiveStep || completedSteps.includes(index)) ? 'underline' : '', position: 'relative', top: '-4px', cursor: (index === globalData?.currentActiveStep || completedSteps.includes(index)) ? 'pointer' : '' }}>
                          {isMobile ? index === globalData?.currentActiveStep ? getBYODText({ index, text: label, pages: globalData.completedPagedForHPB }) : '' : getBYODText({ index, text: label, pages: globalData.completedPagedForHPB })}
                        </div>
                      </Micro>
                    </div>
                  </StepLabel>
                </Step>
              ))}
            </StepperContainer>
          </DivWrapper>
        </div>
      </div>
    )
  } else return <></>
}

export const VZStepper = (props) => {
  const { t } = useTranslation(["app"]);
  const showProgressBar = checkIfAemExists(t("progressbar.enableProgressBar", { ns: "app" }))
  if (showProgressBar) {
    return <VZStepperChild {...props} />
  }
  return <></>
}
